import { IsString } from "../checks/IsString"
import type { AnyGUID, StringGUID } from "../types/GUID"

export const GuidToString = (guid: AnyGUID): StringGUID =>
  IsString(guid) ? guid : (guid.toString(36) as StringGUID)
